module.exports = __webpack_public_path__ + "img/logo_tik.8d114011.png";